import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a21ebd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-analysis-container" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "alert-bar" }
const _hoisted_4 = { class: "content-area" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "资源总数", -1))
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "当月开单均价（元）", -1))
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "stat-label" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "在表开单数", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart1",
  class: "chart-container"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart2",
  class: "chart-container"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart14",
  class: "chart-container"
}, null, -1))
const _hoisted_16 = { class: "chart-container special-chart" }
const _hoisted_17 = { class: "chart-title-bar" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chart-title-text" }, "看直/复播超", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chart-title-text" }, "分钟的客户", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart8",
  class: "chart-inner"
}, null, -1))
const _hoisted_21 = { class: "chart-container call-frequency-chart" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "通话频次数据", -1))
const _hoisted_23 = { class: "frequency-list" }
const _hoisted_24 = { class: "frequency-item blue-gradient" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frequency-label" }, "1次:", -1))
const _hoisted_26 = { class: "frequency-value" }
const _hoisted_27 = { class: "frequency-item red-gradient" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frequency-label" }, "1次及以上:", -1))
const _hoisted_29 = { class: "frequency-value" }
const _hoisted_30 = { class: "frequency-item green-gradient" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frequency-label" }, "2次及以上:", -1))
const _hoisted_32 = { class: "frequency-value" }
const _hoisted_33 = { class: "frequency-item orange-gradient" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frequency-label" }, "3次及以上:", -1))
const _hoisted_35 = { class: "frequency-value" }
const _hoisted_36 = { class: "frequency-item gray-gradient" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frequency-label" }, "5次及以上:", -1))
const _hoisted_38 = { class: "frequency-value" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart9",
  class: "chart-container"
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart7",
  class: "chart-container"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-placeholder" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart6",
  class: "chart-container"
}, null, -1))

import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import localCache from '@/utils/cache'
import { ElLoading,ElAlert } from 'element-plus'
import type { FormInstance } from 'element-plus'
import { getListData } from '@/service/main/system'
import * as echarts from 'echarts'
import {
  queryResourceStatisticsInfo,
} from '@/service/main/inspect/ResourceAnalysis'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceAnalysis',
  setup(__props) {

const store = useStore()
const formatToPercentage = (number: any) => {
  if(number && number > 0){
    const percentage = (number * 100).toFixed(2);
    return `${percentage}%`;
  }else{
    return `0%`;
  }
}
const shortcuts = [
  {
    text: '最近7天',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      return [start, end]
    }
  },
  {
    text: '最近1个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      return [start, end]
    }
  },
  {
    text: '最近3个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 3)
      return [start, end]
    }
  }
]

const formRef = ref<FormInstance>(null);
const queryParam = ref({
  deptId: ref(''),
})

const handleResetClick = () => {
  queryParam.value = {
    deptId: '',
  };
}

const resourceCount = ref(0)
const avgPrice = ref(0)
const chatCount = ref(0)
const chatRate = ref(0)
const chatDealCount = ref(0)
const eq1CallNum = ref(0)
const ge1CallNum = ref(0)
const ge2CallNum = ref(0)
const ge3CallNum = ref(0)
const ge5CallNum = ref(0)

const mins = [
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '30',
    label: '30',
  },
]
const currmins = ref('5')
const liveFubo10CustNum = ref(0)
const liveFubo30CustNum = ref(0)
const liveFubo5CustNum = ref(0)
const updateChart8 = async () => {
  if (myChart8) {
    const n = "看直/复播超" + currmins.value + "分钟的客户数"
    const v = currmins.value == '5' ? liveFubo5CustNum.value :
      currmins.value == '10' ? liveFubo10CustNum.value :
        currmins.value == '30' ? liveFubo30CustNum.value : 0
    const s = resourceCount.value
    myChart8.setOption({
      series: [{ data: [{ value: v, name: n }, { value: s - v, name: '其他' }] }]
    });
  }
}

const initData = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const data = await queryResourceStatisticsInfo(queryParam.value)
  console.log(data,data.status)
  loadingInstance.close()

  resourceCount.value = data.resourceCount
  avgPrice.value = data.currentMonthAvgPrice1
  if (myChart1) {
    myChart1.setOption({
      title: { text: '开单总数' + data.dealCount },
      series: [{ data: [{ value: data.dealCount, name: '开单总数' }, { value: data.resourceCount - data.dealCount, name: '其他' }] }]
    });
  }
  if (myChart2) {
    myChart2.setOption({
      title: { text: '当月开单数' + data.currentMonthDealCount },
      series: [{ data: [{ value: data.currentMonthDealCount, name: '当月开单数' }, { value: data.resourceCount - data.currentMonthDealCount, name: '其他' }] }]
    });
  }
  if (myChart14) {
    myChart14.setOption({
      title: { text: '总资源开单均价' +  (data.resourceCount === 0 ? 0 : (data.dealAmount / data.resourceCount).toFixed(2))   },
      series: [{ data: [{ value: data.dealAmount, name: '总金额' }, { value: data.resourceCount - data.dealAmount, name: '其他' }] }]
    });
  }
  chatCount.value = data.chatCount
  chatRate.value = data.chatRate
  chatDealCount.value = data.chatDealCount
  if (myChart6) {
    myChart6.setOption({
      title: { text: '激活客户数' + data.activateCustNum },
      series: [{ data: [{ value: data.activateCustNum, name: '激活客户数' }, { value: data.resourceCount - data.activateCustNum, name: '其他' }] }]
    });
  }
  eq1CallNum.value = data.eq1CallNum
  ge1CallNum.value = data.ge1CallNum
  ge2CallNum.value = data.ge2CallNum
  ge3CallNum.value = data.ge3CallNum
  ge5CallNum.value = data.ge5CallNum

  if (myChart7) {
    myChart7.setOption({
      title: { text: '看直播/复播客户数' + data.liveFuboCustNum },
      series: [{ data: [{ value: data.liveFuboCustNum, name: '看直播/复播客户数' }, { value: data.resourceCount - data.liveFuboCustNum, name: '其他' }] }]
    });
  }
  if (myChart8) {
    liveFubo5CustNum.value = data.liveFubo5CustNum
    liveFubo10CustNum.value = data.liveFubo10CustNum
    liveFubo30CustNum.value = data.liveFubo30CustNum
    const n = "看直/复播超" + currmins.value + "分钟的客户数"
    myChart8.setOption({
      series: [{ data: [{ value: data.liveFubo5CustNum, name: n }, { value: data.resourceCount - data.liveFubo5CustNum, name: '其他' }] }]
    });
  }

  if (myChart9) {
    myChart9.setOption({
      title: { text: '成交客户看直播/复播' + data.liveFuboDealCustNum },
      series: [{ data: [{ value: data.liveFuboDealCustNum, name: '成交客户看直播复播' }, { value: data.dealCount - data.liveFuboDealCustNum, name: '其他' }] }]
    });
  }
}

const onSubmit = async (formRef: FormInstance) => {
  if (!formRef) return
  await formRef.validate((valid:any, fields:any) => {
    if (valid) {
      console.log('校验成功')
      initData()
    } else {
      console.log('校验失败')
    }
  })
}
let myChart1: echarts.ECharts | null = null;
let myChart2: echarts.ECharts | null = null;
let myChart6: echarts.ECharts | null = null;
let myChart7: echarts.ECharts | null = null;
let myChart8: echarts.ECharts | null = null;
let myChart9: echarts.ECharts | null = null;
let myChart14: echarts.ECharts | null = null;

const option1 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '开单总数',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '开单总数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: '{b}: {c}'
      },
      labelLine: {
        show: false
      },
    }
  ]
}
const option2 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '当月开单数',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '当月开单数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: '{b}: {c}'
      },
      labelLine: {
        show: false
      }
    }
  ]
}
const option6 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '激活客户数',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '激活客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: '{b}: {c}'
      },
      labelLine: {
        show: false
      }
    }
  ]
}
const option7 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '看直播/复播客户数',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '看直播/复播客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: function (params) {
          var maxLength = 5;
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        }
      },
      labelLine: {
        show: false
      }
    }
  ]
}
const option8 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '看直播/复播超过XX分钟的客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['54%', '90%'],
      label: {
        show: true,
        position: 'inside',
        formatter: function (params) {
          var maxLength = 5;
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        }
      },
      labelLine: {
        show: false
      }
    }
  ]
}
const option9 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '成交客户看直播/复播',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '成交客户看直播/复播'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: function (params) {
          var maxLength = 5;
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        }
      },
      labelLine: {
        show: false
      }
    }
  ]
}
const option14 = {
  tooltip: {
    formatter: '{b}: {c}'
  },
  title: {
    text: '总资源开单均价',
    left: 'center',
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '总资源开单均价'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true,
        position: 'inside',
        formatter: function (params) {
          var maxLength = 5;
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.value;
          } else {
            return value + params.value;
          }
        }
      },
      labelLine: {
        show: false
      }
    }
  ]
}

const handleResize = () => {
  [
    myChart1,
    myChart2,
    myChart6,
    myChart7,
    myChart8,
    myChart9,
    myChart14
  ].forEach((chart) => chart?.resize())
}

onMounted(() => {
  initData()
  myChart1 = echarts.init(document.getElementById('myChart1'))
  myChart1.setOption(option1)
  myChart2 = echarts.init(document.getElementById('myChart2'))
  myChart2.setOption(option2)
  myChart6 = echarts.init(document.getElementById('myChart6'))
  myChart6.setOption(option6)
  myChart7 = echarts.init(document.getElementById('myChart7'))
  myChart7.setOption(option7)
  myChart8 = echarts.init(document.getElementById('myChart8'))
  myChart8.setOption(option8)
  myChart9 = echarts.init(document.getElementById('myChart9'))
  myChart9.setOption(option9)
  myChart14 = echarts.init(document.getElementById('myChart14'))
  myChart14.setOption(option14)

  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  myChart1?.dispose()
  myChart2?.dispose()
  myChart6?.dispose()
  myChart7?.dispose()
  myChart8?.dispose()
  myChart9?.dispose()
  myChart14?.dispose()
  myChart1 = null
  myChart2 = null
  myChart6 = null
  myChart7 = null
  myChart8 = null
  myChart9 = null
  myChart14 = null
})
const rules = {
  timeSlot: [{
    required: true,
    message: '加入时间必填',
    trigger: 'change',
  }],
}

const userOptions = localCache.getCache('empData').map((item: any) => {
  return { title: item.realName, value: item.realName }
})

const deptOptions:any = ref({})
const getDept = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  deptOptions.value = deptList.map((item: any) => {
    return {title: item.name, value: item.id};
  })
}
getDept()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        inline: true,
        model: queryParam.value,
        class: "demo-form-inline",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "组别" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: queryParam.value.deptId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParam.value.deptId) = $event)),
                placeholder: "请选择组别",
                clearable: "",
                style: {"width":"200px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deptOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.title,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                onClick: handleResetClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ElAlert), {
        title: "每日晚上11:30半统计出的近90天内新进资源的数据",
        type: "warning",
        "show-icon": "",
        closable: false
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card blue-gradient" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(resourceCount.value), 1),
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card red-gradient" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(avgPrice.value), 1),
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card green-gradient" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(chatCount.value), 1),
                  _createElementVNode("div", _hoisted_10, "上表资源数（" + _toDisplayString(chatRate.value) + "%）", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "stat-card orange-gradient" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(chatDealCount.value), 1),
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "chart-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "chart-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_select, {
                    modelValue: currmins.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currmins).value = $event)),
                    size: "small",
                    style: {"width":"70px","margin":"0 8px"},
                    onChange: updateChart8
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mins, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_19
                ]),
                _hoisted_20
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("span", _hoisted_26, _toDisplayString(eq1CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("span", _hoisted_29, _toDisplayString(ge1CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("span", _hoisted_32, _toDisplayString(ge2CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(ge3CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", _hoisted_38, _toDisplayString(ge5CallNum.value), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "chart-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})